<template>
  <!-- 基础信息 -->
  <!-- SLA时间进度条 -->
  <div>
    <div class="SLA-box" :style="{ paddingBottom: shouldUseCollapse ? '0' : '' }" v-if="showSLABox">
      <van-progress
        :class="{ newProgessClass: shouldUseCollapse }"
        :percentage="percentage"
        :stroke-width="shouldUseCollapse ? 4 : 10"
        :track-color="trackcolor"
        :pivot-text="pivottext"
        :pivot-color="pivotcolor"
        :color="color"
      />
      <div
        class="timeInfo"
        :style="{
          fontSize: shouldUseCollapse ? '12px' : '',
          paddingTop: shouldUseCollapse ? '0' : '',
          paddingBottom: shouldUseCollapse ? '0' : '',
        }"
      >
        <span>剩余时间：</span
        ><!-- 倒计时每秒变化，外层 span 加 data-no-translate="true"
             整体排除翻译，避免每秒触发一次翻译请求。
             注意：data-no-translate 必须写在 DOM 元素上；vant van-count-down
             不会把外部 attribute 透传到自身根 div，所以必须用包裹层。
             format 跟随当前 html lang 切换：非中文用 HH:mm:ss，中文保留"X时X分X秒" -->
        <span data-no-translate="true" class="countdown-noTranslate">
          <van-count-down
            :time="countDown"
            :format="countdownFormat"
            ref="countdowns"
            :style="{ fontSize: shouldUseCollapse ? '12px' : '' }"
          />
        </span>
      </div>
    </div>

    <p v-if="!shouldUseCollapse" class="section-title ml10">工单信息</p>
    <template v-if="shouldUseCollapse">
      <van-collapse v-model="activeName" accordion style="position: relative">
        <van-collapse-item class="ticket-info" title="工单信息" name="1">
          <!-- 工单基本信息 -->
          <van-cell title="工单号" :value="ticketData.TicketId" />
          <van-cell
            title="工单标题"
            title-style="min-width: 20%; min-width: 20%"
            title-class="w10"
            :value="ticketData.Title"
          />
          <van-cell title="工单等级" :value="SLA_LEVEL[ticketData.SLALevel]" />
          <van-cell title="描述" :value="ticketData.Description" class="newDescriptionClass" />
          <van-cell title="单据状态" :value="TICKET_STATUS[ticketData.TicketStatus]" />
          <van-cell v-if="otherTicket && otherTicket.length" title="关联工单">
            <template>
              <div class="flex">
                <el-link
                  v-for="link in otherTicket"
                  :key="link.taskId"
                  class="mr10"
                  type="primary"
                  target="_blank"
                  :href="`/todo-detail?ticketId=${link.TicketId}&taskId=${link.TaskId}`"
                >
                  <span class="color-brand">{{ link.Title || link.TicketId }}</span>
                </el-link>
              </div>
            </template>
          </van-cell>

          <!-- 流程中间数据 -->
          <template v-if="showsData && Object.keys(showsData).length">
            <van-divider>流程中间数据</van-divider>
            <div v-if="showsData.Normal">
              <van-cell
                v-for="viewItem in showsData.Normal"
                :key="viewItem.Key"
                :title="viewItem.name ? viewItem.name + ':' : viewItem.KeyName + ':'"
                label-width="120px"
                :value="viewItem.data || viewItem.Value"
              />
            </div>
            <div v-if="showsData.MultiLineKv">
              <van-cell
                v-for="viewItem in showsData.MultiLineKv"
                :key="viewItem.Key"
                :title="viewItem.name ? viewItem.name + ':' : viewItem.KeyName + ':'"
                label-width="120px"
                :value="viewItem.data || viewItem.Value"
              >
                <span class="pre-line">{{ item.Value }}</span>
              </van-cell>
            </div>
            <div v-if="showsData.Link">
              <van-cell
                is-link
                v-for="viewItem in showsData.Link"
                :key="viewItem.Key"
                :title="viewItem.KeyName ? viewItem.KeyName + ':' : viewItem.name + ':'"
              >
                <a
                  v-if="viewItem.Value"
                  :href="viewItem.Value"
                  class="f12"
                  type="primary"
                  target="_blank"
                >
                  {{ viewItem.Value }}
                </a>
                <a v-else :href="viewItem.data" class="f12" type="primary" target="_blank">
                  {{ viewItem.data }}
                </a>
              </van-cell>
            </div>
            <div v-if="showsData.Json" label-width="120px">
              <van-field
                readonly
                label-width="0"
                v-for="viewItem in showsData.Json"
                :key="viewItem.Key"
              >
                <template #input>
                  <div class="w">
                    <div class="mb10">
                      {{ viewItem.KeyName ? viewItem.KeyName : viewItem.name }}
                    </div>
                    <MonacoJsonEditor
                      style="width: 100%; height: 100px"
                      :content="getJSON(viewItem.Value ? viewItem.Value : viewItem.data)"
                      :editorOption="{
                        theme: 'vs',
                        readOnly: true,
                        fontSize: 13,
                      }"
                    />
                  </div>
                </template>
              </van-field>
            </div>
            <div v-if="showsData.Table">
              <van-field label-width="0" style="padding: 0">
                <template #input>
                  <van-collapse class="w" v-model="tableOpenStatus">
                    <van-collapse-item
                      v-for="viewItem in showsData.Table"
                      :key="viewItem.Key"
                      :name="viewItem.Key"
                    >
                      <template #title>
                        <span class="mb10 mr20">{{
                          viewItem.KeyName ? viewItem.KeyName : viewItem.name
                        }}</span>
                      </template>
                      <div class="w">
                        <el-table
                          v-if="Array.isArray(viewItem.data) && !viewItem.Value"
                          :data="viewItem.data"
                          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                          border
                          class="w"
                          width="100%"
                        >
                          <el-table-column
                            v-for="(val, key) in viewItem.data[0]"
                            :key="key"
                            :prop="key"
                            :label="key"
                            align="center"
                          >
                            <template v-slot="{ row }">
                              <div :class="checkLineWrap(row[key])">
                                {{ row[key] }}
                              </div>
                            </template>
                          </el-table-column>
                        </el-table>
                        <el-table
                          v-else
                          :data="JSON.parse(viewItem.Value)"
                          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                          border
                        >
                          <el-table-column
                            v-for="(val, key) in JSON.parse(viewItem.Value)[0]"
                            :key="key"
                            :prop="key"
                            :label="key"
                            align="center"
                          >
                            <template v-slot="{ row }">
                              <div :class="checkLineWrap(row[key])">
                                {{ row[key] }}
                              </div>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </van-collapse-item>
                  </van-collapse>
                </template>
              </van-field>
            </div>
            <div v-if="showsData.OrderTable">
              <van-field label-width="0" style="padding: 0">
                <template #input>
                  <van-collapse class="w" v-model="OrderTableOpenStatus">
                    <van-collapse-item
                      v-for="viewItem in showsData.OrderTable"
                      :key="viewItem.Key"
                      :name="viewItem.Key"
                    >
                      <template #title>
                        <span class="mb10 mr20">{{
                          viewItem.KeyName ? viewItem.KeyName : viewItem.name
                        }}</span>
                      </template>
                      <div class="w">
                        <el-table
                          v-if="Array.isArray(viewItem.data) && !viewItem.Value"
                          :data="viewItem.data"
                          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                          border
                          class="w"
                          width="100%"
                        >
                          <el-table-column
                            v-for="(key, index) in viewItem.header"
                            :key="index"
                            :prop="key"
                            :label="key"
                            align="center"
                          >
                            <template v-slot="{ row }">
                              <div :class="checkLineWrap(row[key])">
                                {{ row[key] }}
                              </div>
                            </template>
                          </el-table-column>
                        </el-table>
                        <el-table
                          v-else
                          :data="JSON.parse(viewItem.Value).detail"
                          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                          border
                        >
                          <el-table-column
                            v-for="(key, index) in JSON.parse(viewItem.Value).header"
                            :key="index"
                            :prop="key"
                            :label="key"
                            align="center"
                          >
                            <template v-slot="{ row }">
                              <div :class="checkLineWrap(row[key])">
                                {{ row[key] }}
                              </div>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </van-collapse-item>
                  </van-collapse>
                </template>
              </van-field>
            </div>
          </template>

          <!-- 待办基础信息 -->
          <template v-if="todoComponent.length">
            <!-- <van-divider>待办详情</van-divider> -->
            <div v-for="(todoItem, todoIndex) in todoComponent" :key="todoItem.taskId">
              <van-cell title="创建时间" :value="todoItem.CreateTime" />
              <van-cell
                v-show="
                  infoItem.data &&
                  infoItem.name &&
                  !infoItem.name.includes('流程ID') &&
                  infoItem.name !== '任务ID'
                "
                v-for="infoItem in todoItem.nodeBasicInfo"
                :key="infoItem.name"
                :title="infoItem.name"
                :value="infoItem.data || '-'"
              />
              <TodoView :todoIndex="todoIndex" :todoViewsData="todoItem.todoViewsData" />
              <div
                v-if="todoItem.realTime"
                style="display: flex; justify-content: center; align-items: center; padding: 10px 0"
              >
                <el-tag type="warning"> 该表单中的部分数据会实时更新 </el-tag>
              </div>
            </div>
          </template>
        </van-collapse-item>
      </van-collapse>
    </template>

    <!-- 如果shouldUseCollapse为false，保持原样 -->
    <template v-else>
      <van-collapse v-model="activeName" accordion>
        <van-collapse-item
          class="ticket-info"
          :title="activeName === '1' ? '点击收起工单信息' : '点击展开工单信息'"
          name="1"
        >
          <van-cell title="工单号" :value="ticketData.TicketId" />
          <van-cell
            title="工单标题"
            title-style="min-width: 20%; min-width: 20%"
            title-class="w10"
            :value="ticketData.Title"
          />
          <van-cell title="工单等级" :value="SLA_LEVEL[ticketData.SLALevel]" />
          <van-cell title="描述" :value="ticketData.Description" />
          <van-cell title="单据状态" :value="TICKET_STATUS[ticketData.TicketStatus]" />
          <van-cell v-if="otherTicket && otherTicket.length" title="关联工单">
            <template>
              <div class="flex">
                <el-link
                  v-for="link in otherTicket"
                  :key="link.taskId"
                  class="mr10"
                  type="primary"
                  target="_blank"
                  :href="`/todo-detail?ticketId=${link.TicketId}&taskId=${link.TaskId}`"
                >
                  <span class="color-brand">{{ link.Title || link.TicketId }}</span>
                </el-link>
              </div>
            </template>
          </van-cell>
        </van-collapse-item>
      </van-collapse>
      <van-collapse
        v-model="activeNameArgs"
        accordion
        v-if="showsData && Object.keys(showsData).length"
      >
        <van-collapse-item
          :title="activeNameArgs === '1' ? '点击收起流程中间数据' : '点击展开流程中间数据'"
          name="1"
          class="ticket-info"
        >
          <div v-if="showsData.Normal">
            <!-- kv类型 兼容流程中间数据 -->
            <van-cell
              v-for="viewItem in showsData.Normal"
              :key="viewItem.Key"
              :title="viewItem.name ? viewItem.name + ':' : viewItem.KeyName + ':'"
              label-width="120px"
              :value="viewItem.data || viewItem.Value"
            />
          </div>
          <div v-if="showsData.MultiLineKv">
            <van-cell
              v-for="viewItem in showsData.MultiLineKv"
              :key="viewItem.Key"
              :title="viewItem.name ? viewItem.name + ':' : viewItem.KeyName + ':'"
              label-width="120px"
              :value="viewItem.data || viewItem.Value"
            >
              <span class="pre-line">{{ item.Value }}</span>
            </van-cell>
          </div>

          <!-- link类型 兼容流程中间数据 -->
          <div v-if="showsData.Link">
            <van-cell
              is-link
              v-for="viewItem in showsData.Link"
              :key="viewItem.Key"
              :title="viewItem.KeyName ? viewItem.KeyName + ':' : viewItem.name + ':'"
            >
              <a
                v-if="viewItem.Value"
                :href="viewItem.Value"
                class="f12"
                type="primary"
                target="_blank"
              >
                {{ viewItem.Value }}
              </a>
              <a v-else :href="viewItem.data" class="f12" type="primary" target="_blank">
                {{ viewItem.data }}
              </a>
            </van-cell>
          </div>
          <!-- json类型 -->
          <div v-if="showsData.Json" label-width="120px">
            <van-field
              readonly
              label-width="0"
              v-for="viewItem in showsData.Json"
              :key="viewItem.Key"
            >
              <template #input>
                <div class="w">
                  <div class="mb10">{{ viewItem.KeyName ? viewItem.KeyName : viewItem.name }}</div>
                  <MonacoJsonEditor
                    style="width: 100%; height: 100px"
                    :content="getJSON(viewItem.Value ? viewItem.Value : viewItem.data)"
                    :editorOption="{
                      theme: 'vs',
                      readOnly: true,
                      fontSize: 13,
                    }"
                  />
                </div>
              </template>
            </van-field>
          </div>

          <!-- 无序table类型 -->
          <div v-if="showsData.Table">
            <van-field label-width="0" style="padding: 0">
              <template #input>
                <van-collapse class="w" v-model="tableOpenStatus">
                  <van-collapse-item
                    v-for="viewItem in showsData.Table"
                    :key="viewItem.Key"
                    :name="viewItem.Key"
                  >
                    <template #title>
                      <span class="mb10 mr20">{{
                        viewItem.KeyName ? viewItem.KeyName : viewItem.name
                      }}</span>
                    </template>
                    <div class="w">
                      <el-table
                        v-if="Array.isArray(viewItem.data) && !viewItem.Value"
                        :data="viewItem.data"
                        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                        border
                        class="w"
                        width="100%"
                      >
                        <el-table-column
                          v-for="(val, key) in viewItem.data[0]"
                          :key="key"
                          :prop="key"
                          :label="key"
                          align="center"
                        >
                          <template v-slot="{ row }">
                            <div :class="checkLineWrap(row[key])">
                              {{ row[key] }}
                            </div>
                          </template>
                        </el-table-column>
                      </el-table>
                      <el-table
                        v-else
                        :data="JSON.parse(viewItem.Value)"
                        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                        border
                      >
                        <el-table-column
                          v-for="(val, key) in JSON.parse(viewItem.Value)[0]"
                          :key="key"
                          :prop="key"
                          :label="key"
                          align="center"
                        >
                          <template v-slot="{ row }">
                            <div :class="checkLineWrap(row[key])">
                              {{ row[key] }}
                            </div>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </van-collapse-item>
                </van-collapse>
              </template>
            </van-field>
          </div>
          <!-- 有序OrderTable类型 -->
          <div v-if="showsData.OrderTable">
            <van-field label-width="0" style="padding: 0">
              <template #input>
                <van-collapse class="w" v-model="OrderTableOpenStatus">
                  <van-collapse-item
                    v-for="viewItem in showsData.OrderTable"
                    :key="viewItem.Key"
                    :name="viewItem.Key"
                  >
                    <template #title>
                      <span class="mb10 mr20">{{
                        viewItem.KeyName ? viewItem.KeyName : viewItem.name
                      }}</span>
                    </template>
                    <div class="w">
                      <el-table
                        v-if="Array.isArray(viewItem.data) && !viewItem.Value"
                        :data="viewItem.data"
                        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                        border
                        class="w"
                        width="100%"
                      >
                        <el-table-column
                          v-for="(key, index) in viewItem.header"
                          :key="index"
                          :prop="key"
                          :label="key"
                          align="center"
                        >
                          <template v-slot="{ row }">
                            <div :class="checkLineWrap(row[key])">
                              {{ row[key] }}
                            </div>
                          </template>
                        </el-table-column>
                      </el-table>
                      <el-table
                        v-else
                        :data="JSON.parse(viewItem.Value).detail"
                        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                        border
                      >
                        <el-table-column
                          v-for="(key, index) in JSON.parse(viewItem.Value).header"
                          :key="index"
                          :prop="key"
                          :label="key"
                          align="center"
                        >
                          <template v-slot="{ row }">
                            <div :class="checkLineWrap(row[key])">
                              {{ row[key] }}
                            </div>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </van-collapse-item>
                </van-collapse>
              </template>
            </van-field>
          </div>
        </van-collapse-item>
      </van-collapse>
    </template>
  </div>
</template>

<script>
import { getRelateTicket, getSLAdata } from '@/api/tickets/ticketsApi';
import { TICKET_STATUS, SLA_LEVEL } from './constant';
import { mapActions, mapGetters } from 'vuex';
import MonacoJsonEditor from '@/components/MonacoJsonEditor';
import TodoView from './todoView.vue';
import { pageTranslator, SOURCE_LANG } from '@/utils/pageTranslator';

export default {
  name: 'TicketDetail',
  components: { MonacoJsonEditor, TodoView },
  props: {
    ticketData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    todoComponent: {
      type: Array,
      default: () => [],
    },
    shouldUseCollapse: {
      type: Boolean,
      default: false,
    },
    schemeData: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      TICKET_STATUS,
      SLA_LEVEL,
      activeName: '',
      activeNameArgs: '',
      otherTicket: [],
      showsData: [],
      tableOpenStatus: [],
      OrderTableOpenStatus: [],
      countDown: '',
      percentage: 0,
      trackcolor: '',
      pivottext: '',
      pivotcolor: '#1989fa',
      color: '',
      states: false,
      OLAstatus: null,
      // 当前页面语言（响应 pageTranslator 切换），用于动态切 van-count-down 的 format
      currentTranslateLang: SOURCE_LANG,
      _unsubscribeTranslateLang: null,
    };
  },
  computed: {
    ...mapGetters(['getConfigItem']),
    /**
     * 倒计时格式：根据当前页面语言动态切换
     *   中文：HH 时 mm 分 ss 秒
     *   其他：HH:mm:ss（数字 + 冒号，跨语言通用，无需翻译）
     * 注意：van-count-down 的整段已加 data-no-translate="true"，
     *   不会被翻译引擎扫到，所以这里也不会触发"每秒翻译"。
     *   format 切换只是在用户切语言时换一次，不影响性能。
     */
    countdownFormat() {
      const lang = this.currentTranslateLang || SOURCE_LANG;
      if (lang === SOURCE_LANG || (typeof lang === 'string' && lang.startsWith('zh'))) {
        return 'HH 时 mm 分 ss 秒';
      }
      return 'HH:mm:ss';
    },
    // 是否显示 SLA-box
    showSLABox() {
      // 如果 OLAstatus 为 false，不显示
      if (!this.OLAstatus) {
        return false;
      }
      // 如果 schemeData.FlowData.properties.countdownEnabled 为 false，不显示
      const countdownEnabled = this.schemeData?.FlowData?.properties?.countdownEnabled;
      if (countdownEnabled === false) {
        return false;
      }
      // 其他情况都显示
      return true;
    },
  },

  created() {
    try {
      const key = this.$store.state.config.ProcessDefinitionKey;
      const processArr = JSON.parse(this.getConfigItem('ProcessDefinitionKey'));
      if (processArr.process.includes(key)) {
        this.OLAstatus = false;
      } else {
        this.OLAstatus = true;
      }
    } catch (error) {
      this.OLAstatus = true;
      console.log(error);
    }
  },
  mounted() {
    this.getRelateTicket();
    this.dealShowsData();
    this.getSLAdata();
    // 订阅页面语言变化：收到通知后更新 currentTranslateLang，
    // computed countdownFormat 会自动重算并把新 format 传给 van-count-down。
    // 注意：onLangChange 订阅时会立即回调一次当前语言，所以无需手动初始化。
    try {
      this._unsubscribeTranslateLang = pageTranslator.onLangChange((lang) => {
        this.currentTranslateLang = lang || SOURCE_LANG;
      });
    } catch (e) { /* ignore */ }
  },
  beforeDestroy() {
    if (typeof this._unsubscribeTranslateLang === 'function') {
      try { this._unsubscribeTranslateLang(); } catch (e) { /* ignore */ }
      this._unsubscribeTranslateLang = null;
    }
  },
  methods: {
    ...mapActions(['setTimeStatus']),
    async getRelateTicket() {
      try {
        const { data } = await getRelateTicket(this.$route.query.ticketId);
        this.otherTicket = [
          ...(data.OtherTicketInfo.filter((item) => item.TicketId && item.TaskId) || []),
        ];
        if (
          data.ParentTicketInfo &&
          data.ParentTicketInfo.TicketId &&
          data.ParentTicketInfo.TaskId
        ) {
          this.otherTicket.push(data.ParentTicketInfo);
        }
      } catch (e) {
        console.log(e);
      }
    },
    dealShowsData() {
      if (!this.ticketData.CustomKV) return;
      const sortData = {
        Normal: [],
        MultiLineKv: [],
        Link: [],
      };
      this.ticketData.CustomKV.forEach((item) => {
        if (!item.Type || item.Type === 'KVField') {
          if (item.Value.includes('\n')) {
            sortData.MultiLineKv.push(item);
          } else {
            sortData.Normal.push(item);
          }
        } else if (item.Type === 'Link' || item.Type === 'Url') {
          sortData.Link.push(item);
        } else if (sortData[item.Type]) {
          sortData[item.Type].push(item);
        } else {
          sortData[item.Type] = [item];
        }
      });
      // 清除空白属性
      if (sortData.Normal.length === 0) {
        delete sortData.Normal;
      }
      if (sortData.Link.length === 0) {
        delete sortData.Link;
      }
      if (sortData.MultiLineKv.length === 0) {
        delete sortData.MultiLineKv;
      }
      this.showsData = sortData;
    },
    dealOpenStatus() {
      const { Table, OrderTable } = this.showsData;
      if (Table) {
        Table.forEach((item) => {
          if (item.IsHidden === '0' || item.openStatus) {
            this.tableOpenStatus.push(item.Key);
          }
        });
      }
      if (OrderTable) {
        OrderTable.forEach((item) => {
          if (item.IsHidden === '0' || item.openStatus) {
            this.OrderTableOpenStatus.push(item.Key);
          }
        });
      }
    },
    // 展开Table详情
    handleTableChange(val, todoItem) {
      todoItem.openStatus = !todoItem.openStatus;
      if (!val || todoItem.initStatus) {
        return;
      }
      if (!todoItem.data) {
        todoItem.data = [];
      }
      if (!todoItem.header) {
        const [headerData = {}] = todoItem.data;
        this.$set(todoItem, 'header', todoItem.data.length ? headerData : []);
      }
      todoItem.initStatus = true;
    },
    checkLineWrap(val) {
      if (typeof val === 'string') {
        return val.includes('\n') ? 'pre-line' : '';
      }
      return '';
    },
    getJSON(str) {
      try {
        const newStr = str
          .replace(/'/g, '"')
          .replace(/True/g, true)
          .replace(/False/g, false)
          .replace(/None/g, null);
        return JSON.stringify(JSON.parse(newStr), null, 2);
      } catch (err) {}
    },
    //获取待办工单流程时间
    async getSLAdata() {
      const TaskId = this.$route.query.taskId;
      try {
        const result = await getSLAdata(TaskId);
        const { data, status } = result;
        this.onload(data);
        if (status === 0) {
          // let endTime = 100
          // let StartTime = 0
          // let nowTime = 80
          const intervalId = setInterval(() => {
            const nowTime = Math.floor(new Date().getTime() / 1000);
            const total = data.EndTime - data.StartTime;
            const elapsed = nowTime - data.StartTime;
            const progress = Math.floor(Math.min((elapsed / total) * 100, 100));
            // debugger

            if (nowTime >= data.EndTime) {
              clearInterval(intervalId);
              this.percentage = progress;
              this.trackcolor = '#ee0a24';
              this.pivottext = `${progress}%超时`;
              this.pivotcolor = '#ee0a24';
              this.color = '#ee0a24';
            } else if (progress >= data.OverDesc * 100) {
              this.percentage = progress;
              this.pivottext = `${progress}%即将超时`;
              this.pivotcolor = '#e6a23c';
              this.color = '#e6a23c';
            } else {
              this.percentage = progress;
              this.pivottext = `${progress}%`;
              // console.log(this.percentage, '百分比');
            }
          }, 1000);
        }
      } catch (e) {
        console.log(e);
      }
    },

    onload(data) {
      //组件需转换成毫秒
      const nowTime = Math.floor(new Date().getTime() / 1000);
      const timeDiff = data.EndTime - nowTime;
      // 如果当前时间早于开始时间，则将开始时间作为倒计时的起点
      if (nowTime < data.StartTime) {
        timeDiff = data.StartTime - nowTime;
        this.countDown = timeDiff * 1000;
      } else {
        this.countDown = timeDiff * 1000;
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .newProgessClass .van-progress__pivot {
  font-size: 8px;
  min-width: 24px;
}
/deep/ .newDescriptionClass .van-cell__value {
  white-space: pre-wrap;
  text-align: left;
}
.van-cell__value {
  min-width: 70%;
}
.ticket-info.van-collapse-item {
  /deep/ .van-collapse-item__content {
    padding: 0;
  }
  /deep/ .van-collapse-item__title span {
    color: #333;
  }
}
.SLA-box {
  padding-bottom: 10px;
}
.timeInfo {
  display: flex;
  padding: 10px 0 0 5px;
  align-items: center;
}
</style>
